import Vue from 'vue'

// 全局事件总线
export const eventBus = new Vue()

/**
 * 全局提示插件
 * 提供 $toast 和 $confirm 方法
 */
export default {
  install(Vue) {
    // Toast 提示
    Vue.prototype.$toast = {
      show(message, type = 'info', duration = 2500) {
        eventBus.$emit('toast:show', { message, type, duration })
      },
      success(message, duration) { this.show(message, 'success', duration) },
      error(message, duration) { this.show(message, 'error', duration) },
      warning(message, duration) { this.show(message, 'warning', duration) },
      info(message, duration) { this.show(message, 'info', duration) }
    }

    // Confirm 确认框
    Vue.prototype.$confirm = function(options) {
      return new Promise((resolve) => {
        eventBus.$emit('confirm:show', { ...options, resolve })
      })
    }
  }
}
